import { render, staticRenderFns } from "./ApiCallStat.vue?vue&type=template&id=dbf03784&scoped=true"
import script from "./ApiCallStat.vue?vue&type=script&lang=js"
export * from "./ApiCallStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf03784",
  null
  
)

export default component.exports